var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.profile.tabs.personal_data.personal"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      modalLarge: true,
      "loading-primary-footer-button": _vm.isLoading,
      showSecondaryFooterButton: false,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "profile" }, [
              _c("article", [
                _vm.error
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" },
                      },
                      [_vm._v(" " + _vm._s(_vm.error) + " ")]
                    )
                  : _vm._e(),
                _c("form", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.canEditPaymentIBan
                          ? _c("employee-iban-field", {
                              attrs: {
                                required: true,
                                id: "edit-employee-iban",
                                name: "iban",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.canEditPaymentSwift
                          ? _c("employee-swift-code-field", {
                              ref: "swiftCode",
                              attrs: {
                                id: "edit-employee-swift-code",
                                name: "swiftCode",
                                form: _vm.form,
                                required: true,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }